// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "95d06213167b81a64ef9b6a87ff58fd9146894e7/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","41":"a0ec33ed","777":"dfb468f1","788":"c61fe626","804":"51a6e114","810":"5b7541cc"}[chunkId] + ".chunk.js";
};